import { ApplicationConfig, provideEnvironmentInitializer, inject } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient } from '@angular/common/http';
import { LoaderTelemetryService } from './core/telemetry/loader-telemetry.service';
import { ErrorPageTelemetryService } from './core/telemetry/error-page-telemetry.service';
import { NotFoundPageTelemetryService } from './core/telemetry/not-found-page-telemetry.service';
import { CurrencyPipe } from '@angular/common';
import { PaymentFlowTelemetryService } from './core/telemetry/payment-flow-telemetry.service';
import { PaymentApiTelemetryService } from './core/telemetry/payment-api-telemetry.service';
import { initSessionId } from './core/session/session-id';

// Force instantiate telemetry services so their event subscriptions are active
export function initTelemetryFactory() {
  inject(LoaderTelemetryService);
  inject(ErrorPageTelemetryService);
  inject(NotFoundPageTelemetryService);
  inject(PaymentFlowTelemetryService);
  inject(PaymentApiTelemetryService);
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(),
    CurrencyPipe,
    LoaderTelemetryService,
    ErrorPageTelemetryService,
    NotFoundPageTelemetryService,
    PaymentFlowTelemetryService,
    PaymentApiTelemetryService,
    provideEnvironmentInitializer(initTelemetryFactory),
    // Ensure a sessionId exists as early as possible
    provideEnvironmentInitializer(() => initSessionId())
  ]
};
